export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_green_p.b121a698.jpg";